// help-center-panel.service.ts
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface HelpCenterOpenPayload {
  /** 必填：功能頁權限代碼 */
  permissionCode: string;
  /** 可選：語系 */
  lang?: string;

  /** 可選：預載（避免首次閃爍） */
  guideHeader?: string;
  releasedGuideContent?: string;
  releasedGuideContentIT?: string;

  /** 可選：預設顯示的分頁（'USER' | 'IT'） */
  activeTab?: 'USER' | 'IT';
}

@Injectable({ providedIn: 'root' })
export class HelpCenterPanelService {
  /** 開啟面板事件（Sidepanel 組件訂閱這個來開啟並載入內容） */
  private _open$ = new Subject<HelpCenterOpenPayload>();
  /** 關閉面板事件（可由外部發起關閉） */
  private _close$ = new Subject<void>();

  /** 對外公開可訂閱的 Observable */
  get open$(): Observable<HelpCenterOpenPayload> { return this._open$.asObservable(); }
  get close$(): Observable<void> { return this._close$.asObservable(); }

  /**
   * 開啟右側面板
   * - 可傳入預載內容（guideHeader / released...）以減少白屏
   * - activeTab 可預設顯示 USER 或 IT
   */
  open(payload: HelpCenterOpenPayload): void {
    this._open$.next({
      ...payload,
      activeTab: payload.activeTab ?? 'USER'
    });
  }

  /** 主動關閉面板（通常由面板內部呼叫，但也開放外部呼叫） */
  close(): void {
    this._close$.next();
  }
}
